/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptiondreamer3Inputs */



/**
* | output |
* | --- |
* | "You know how to enjoy the little things. You love noticing the bright side in people, staying sincere, and believing that in the end things somehow work out ..." |
*
* @param {Personalityarchetypedescriptiondreamer3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptiondreamer3 = /** @type {((inputs?: Personalityarchetypedescriptiondreamer3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptiondreamer3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You know how to enjoy the little things. You love noticing the bright side in people, staying sincere, and believing that in the end things somehow work out for the best.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sabes cómo disfrutar de las pequeñas cosas. Te encanta notar el lado positivo de las personas, mantener la sinceridad y creer que todo saldrá bien.")
	return /** @type {LocalizedString} */ ("Ты умеешь радоваться мелочам. Тебе нравится замечать светлую сторону в людях, сохранять искренность и верить, что в итоге всё всегда складывается к лучшему.")
});
export { personalityarchetypedescriptiondreamer3 as "personalityArchetypeDescriptionDreamer" }